export enum DeviceType {
    mobile,
    desktop,
}
